import React from "react";
import Chart from "chart.js/auto";
import { Bar } from "react-chartjs-2";
import annotationPlugin from "chartjs-plugin-annotation";

Chart.register(annotationPlugin);

// Configuración de las variables de Evasión Conductual
const EC_CONFIG = [
  { nombre: "EC Cinismo", campo: "EC_Cinismo" },
  { nombre: "EC Superstición", campo: "EC_Supersticion" },
  { nombre: "EC Influencia", campo: "EC_Influencia" },
  { nombre: "EC Prudencia", campo: "EC_Prudencia" },
  { nombre: "EC Autoregulación", campo: "EC_Autoregulacion" },
  { nombre: "EC Responsabilidad", campo: "EC_Responsabilidad" },
  { nombre: "EC Vitalidad", campo: "EC_Vitalidad" },
  { nombre: "EC Apertura", campo: "EC_Apertura" },
  { nombre: "EC Total", campo: "Fraccion_EC" },
];

const GraficoEC = (props) => {
  const { item } = props;

  const etiquetas = EC_CONFIG.map((v) => v.nombre);
  const valores = EC_CONFIG.map((v) => parseFloat(item[v.campo] || 0));

  const backgroundColors = valores.map(
    (v) =>
      v >= 50
        ? "rgb(198, 107, 106)" // rojo: alto
        : v >= 30
          ? "rgb(210, 196, 187)" // beige: medio
          : "rgba(18, 135, 171, 0.8)", // azul: bajo
  );

  const data = {
    labels: etiquetas,
    datasets: [
      {
        label: "%",
        data: valores,
        backgroundColor: backgroundColors,
        borderColor: "rgb(200, 200, 200)",
        barPercentage: 0.6,
      },
    ],
  };

  const options = {
    indexAxis: "x",
    maintainAspectRatio: false,
    responsive: true,
    scales: {
      y: {
        min: 0,
        max: 100,
        ticks: {
          stepSize: 20,
          font: { size: 10 },
          callback: (value) => `${value}%`,
        },
        title: {
          display: true,
          text: "Porcentaje (%)",
          font: { size: 11 },
        },
      },
      x: {
        ticks: {
          font: { size: 11 },
        },
      },
    },
    plugins: {
      tooltip: {
        callbacks: {
          label: (context) => `${context.parsed.y}%`,
        },
      },
      legend: {
        display: false,
      },
      title: {
        display: false,
      },
      annotation: {
        annotations: {
          line50: {
            type: "line",
            yMin: 50,
            yMax: 50,
            borderColor: "rgba(192, 80, 77, 0.8)",
            borderWidth: 1.5,
            borderDash: [4, 4],
            label: {
              content: "50%",
              enabled: true,
              position: "end",
              font: { size: 9 },
            },
          },
        },
      },
    },
  };

  return (
    <Bar
      options={options}
      data={data}
      style={{ height: "100%", width: "100%" }}
    />
  );
};

const GraficoECWrapper = (props) => {
  return (
    <div style={{ height: "100%", width: "100%" }}>
      <GraficoEC {...props} />
    </div>
  );
};

export default GraficoECWrapper;
